import PropTypes from "prop-types"

import _ from "lodash"

import React, { useState, useEffect } from "react"

import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, Redirect, useParams, useLocation } from "react-router-dom"

import withRouter from "components/Common/withRouter"

import Select from "react-select"

import { getSession, logout } from "helpers/AuthType/authService"

import { Birthdate } from "components/Common/DatePicker"

// Formik validation
import { useFormik } from "formik"

import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
// actions
import {
  loginConsole,
  loginUser,
  loginCoUser,
} from "store/actions"

//Import SelectWithValidation
import Toastr from "components/Common/toastr"

//Global Functions
import { findElementPositionById, regexp } from "common/global/functions.js"

// Modals
//import Modals from "../Modals";

const CustomerApplication = props => {
  //meta title
  document.title = "Loading Information | Equity Sales Finance, INC."

 const params = useParams()
  const location = useLocation();

  const [redirect, setRedirect] = useState(true)
  const [routes, setRoutes] = useState(location.hasOwnProperty('pathname') ? _.split(location.pathname, '/') : [])
  
    const [activeTab, setactiveTab] = useState(0)

  useEffect(() => {
    console.log({params, routes})
    if (params.guid) {
        window.location.assign(`https://customerapps.equitysalesfinance.com/customer/documents/authoritative-copy/${params.guid}`)
    }
  }, [redirect])

  return (
        <div className="page-content">
                <Container fluid={true}>
                  <Breadcrumbs title={""} breadcrumbItem={""} />
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4"></CardTitle>
        
                        <div className="wizard clearfix">
                          <div className="steps clearfix ms-10">
                            <ul>
                              <NavItem className={"card-title placeholder-glow"}>
                                <NavLink
                                  className={"placeholder col-12"}
                                  disabled={true}
                                >
                                  <span className="">
Step 1 : Customer Authentication <br/>
Please fill in the form below for authentication purposes in order to proceed.
</span> &nbsp;
                                </NavLink>
                              </NavItem>
                              <NavItem className={"card-title placeholder-glow"}>
                                <NavLink
                                  className={"placeholder col-12"}
                                  disabled={true}
                                >
                                  <span className="">
Step 2 : Download <br/>
Follow the download instructions below
</span> &nbsp;
                                </NavLink>
                              </NavItem>
                            </ul>
                          </div>
                          {/* End Wizard Steps */}
                          <div className="content clearfix">
                            <TabContent activeTab={activeTab} className="body">
                              <TabPane tabId={0}>
                                <Row>
                                  <Col lg="6">
                                    <div className="mb-3 card-title placeholder-glow">
                                    <Label className={"placeholder"}>Why Authenticate?</Label>
                                      <p className={"placeholder"}>
                                      The paid in full contract you are about to download is the one and only authoritative original available. Once downloaded make sure to store it in a secure place for your own personal records.
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6">
                                    <div className="mb-3 card-title placeholder-glow">
                                    <Label className={"placeholder"}>Last Four SSN</Label>
                                      <Input
                                        type="text"
                                        placeholder=""
                                        disabled={true}
                                        className={"placeholder col-12"}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="4">
                                    <div className="mb-3 card-title placeholder-glow">
                                      <Label>&nbsp;</Label>
                                    </div>
                                  </Col>
                                  <Col lg="4">
                                    <div className="mb-3 card-title placeholder-glow">
                                      <Label>&nbsp;</Label>
                                    </div>
                                  </Col>
                                  <Col lg="4">
                                    <div className="mb-3 card-title placeholder-glow">
                                      <Label>&nbsp;</Label>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6">
                                    <div className="mb-3 card-title placeholder-glow">
                                      <Label>&nbsp;</Label>
                                    </div>
                                  </Col>
                                  <Col lg="6">
                                    <div className="mb-3 card-title placeholder-glow">
                                      <Label>&nbsp;</Label>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6">
                                    <div className="mb-3 card-title placeholder-glow">
                                      <Label>&nbsp;</Label>
                                    </div>
                                  </Col>
                                  <Col lg="6">
                                    <div className="mb-3 card-title placeholder-glow">
                                      <Label>&nbsp;</Label>
                                      
                                    </div>
                                  </Col>
                                </Row>
                              </TabPane>
                            </TabContent>
                          </div>
        
                          <div className="clearfix">
                            <Row>
                            <Col lg="4"></Col>
                            <Col lg="4">
                                <Link
                                  to="#"
                                  className="btn btn-warning disabled placeholder col-12"
                                >
                                  Next
                                </Link>
                                </Col>
                            </Row>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Container>
              </div> 
  )
}

export default withRouter(CustomerApplication)

CustomerApplication.propTypes = {
  history: PropTypes.object,
}
